// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","showcase":"vi7m7gJg0jlGJANV0JfO3","showcaseItem":"_30V-Pmk9dDIiTnxPBfcbww","showcaseCheckItem":"_23cpjoP7lCSBu8KpOlHHhx"};